const documentKeyToEnum: Record<string, string> = {
  moaAoa: "moa_aoa",
  certificateOfIncorporation: "certificate_incorporation",
  pan_entity: "pan_entity",
  gstRegistrationCertificate: "gst_certificate",
  gstCertificate: "gst_certificate",
  listOfShareholders: "shareholder_list",
  listOfDirectors: "director_list",
  kycDirectors: "director_list", // Adjust if needed
  kycUbos: "shareholder_list", // Adjust if needed
  bankStatementOneYear: "bank_statement",
  bankStatementOneYearPartnership: "bank_statement",
  itrTwoYears: "itr",
  itrTwoFinancialYears: "itr",
  declarationNatureOfBusiness: "business_declaration",
  declarationAuthorisedSignatories: "authorised_signatory_declaration",
  declarationSourceOfWealth: "wealth_source_declaration",
  partnershipDeed: "partnership_deed",
  msmeUdyamAayogCertificate: "msme_certificate",
  registrationCertificate: "registration_certificate",
  panOfFirm: "pan_entity",
  operationalOfficeAddressProof: "office_proof",
  kycAllPartners: "director_list", // Adjust if needed
  declarationsAndUndertakings: "other_declaration",
};

export default documentKeyToEnum; 